module.exports = __webpack_public_path__ + "img/new-login-logo.78b3870c.png";